function copiarAlPortapapeles(texto_copiar) {
    var aux = document.createElement("input");

    aux.setAttribute("value", texto_copiar);

    document.body.appendChild(aux);

    aux.select();

    document.execCommand("copy");

    document.body.removeChild(aux);

    const resultado = document.getElementById('compartir-resultado');
    resultado.innerText = 'Copiado al portapapeles';
    resultado.style.display = "block";

    setTimeout(function () {
        resultado.style.display = "none";
    }, 1800)

}

const toClipboard = document.getElementById('to_clipboard');
if (toClipboard) {
    toClipboard.addEventListener('click', function (event){
        event.preventDefault();
        copiarAlPortapapeles(this.getAttribute('href'));
    })
}
